import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { LoginAgainService } from '../../services/login-again.service';
import { CookieManagerService } from '../../services/cookie-manager.service';

declare var $: any

@Component({
  selector: 'app-login-again',
  templateUrl: './login-again.component.html'
})
export class LoginAgainComponent implements OnInit {

  @ViewChild('loginAgain') loginAgain:ElementRef;

  constructor(private loginAgainService: LoginAgainService, private cookieService: CookieManagerService) {
    loginAgainService.status.subscribe((open: any) => {
        if(open){
          $(this.loginAgain.nativeElement).modal({backdrop: 'static', keyboard: false}) 
          $(this.loginAgain.nativeElement).modal('show');
        }
    });
  }

  ngOnInit() {
  }

  onClickYes(){
    this.loginAgainService.isOpen(false);
    location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modules/modal-login-again/login-again.component.ts